// This is the entry point for the home component
import React, { FC, useContext } from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// GraphQL
// eslint-disable-next-line import/no-extraneous-dependencies
import { useQuery } from '@apollo/react-hooks';

// Styling
import injectSheet from 'react-jss';

// Actions

// Utilities
import { areEqual } from 'Utils/areEqual';

import withErrorBoundary from 'HOC/ErrorBoundary';

import { Accordion } from 'Components/Accordion';
import { FilterRadioHidden } from 'Components/FilterRadioHidden';
import UserDetailsContext from 'Context/userDetailsContext';
import styleSheet from './styles';
import { allLocationsGQL } from './gqlQuery';

import { setLocations } from './actions/locations.action';

interface Props {
  classes: any;
}

const Locations: FC<Props> = (props: Props) => {
  const { locations } = useSelector((selectors: any) => selectors.filter);

  const dispatch = useDispatch();

  const userDetails = useContext(UserDetailsContext);
  const { data: locationsData } = useQuery(allLocationsGQL, {
    variables: {
      instId: userDetails.instId,
    },
  });

  const locationResp = locationsData?.institutions?.locations;

  const allLocationIds = locationResp?.map((location: any) => location.loc_id);

  const vtLocations = locationResp?.filter(
    (location: any) => location.name !== '' && location.experience_type === 'vt'
  );

  const iwcLocations = locationResp?.filter(
    (location: any) =>
      location.name !== '' && location.experience_type === 'iwc'
  );

  const vtLocationIds = vtLocations?.map((location: any) => location.loc_id);
  const iwcLocationIds = iwcLocations?.map((location: any) => location.loc_id);

  const isVT =
    vtLocationIds?.includes(locations?.locationIds?.[0]) &&
    locations?.locationIds?.length === 1;

  const isIWC =
    iwcLocationIds?.includes(locations?.locationIds?.[0]) &&
    locations?.locationIds?.length === 1;

  const { classes } = props;
  const overrideStyles = { paddingLeft: '0px' };

  return (
    <ul className={classes.container}>
      <li>
        <FilterRadioHidden
          selected={
            !locations?.locationIds?.length ||
            areEqual(locations.locationIds, allLocationIds)
          }
          label="ALL"
          value="ALL"
          overrideStyles={overrideStyles}
          onClick={() => {
            setLocations(dispatch, allLocationIds);
          }}
        />
      </li>
      <li>
        <Accordion
          title="VT"
          id="vt"
          isOpen={isVT}
          accordionCallback={() => {
            setLocations(dispatch, [vtLocationIds[0]]);
          }}
          useTopDivider={false}
          useBottomDivider={false}
          accordionType="FilterRadioHidden"
          isActive={isVT}
          overrideStylesChildContainer={{
            marginLeft: '20px',
          }}
        >
          <div className={classes.innerContainer}>
            {vtLocations?.map((location) => {
              return (
                <FilterRadioHidden
                  label={location.name}
                  value={location.name}
                  selected={location.loc_id === locations?.locationIds?.[0]}
                  identifier={location}
                  onClick={() => {
                    setLocations(dispatch, [location.loc_id]);
                  }}
                />
              );
            })}
          </div>
        </Accordion>
      </li>
      <li>
        <Accordion
          title="IWC"
          id="iwc"
          isOpen={isIWC}
          accordionCallback={() => {
            setLocations(dispatch, [iwcLocationIds[0]]);
          }}
          useTopDivider={false}
          useBottomDivider={false}
          accordionType="FilterRadioHidden"
          isActive={isIWC}
          overrideStylesChildContainer={{
            marginLeft: '20px',
          }}
        >
          <div className={classes.innerContainer}>
            {iwcLocations?.map((location) => {
              return (
                <FilterRadioHidden
                  label={location.name}
                  value={location.name}
                  selected={location.loc_id === locations?.locationIds?.[0]}
                  identifier={location}
                  onClick={() => {
                    setLocations(dispatch, [location.loc_id]);
                  }}
                />
              );
            })}
          </div>
        </Accordion>
      </li>
    </ul>
  );
};

export default withErrorBoundary(injectSheet(styleSheet)(Locations));
